<template>
    <v-container class="mb-6">

        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>

        <div class="mb-2">
            {{ date }}
        </div>
        <v-card class="mb-4" :loading="loading">
            <v-card-title>
                {{$t('Detalles del pedido')}} #{{ numberOrder }}
                <small class="grey--text ml-3">{{$t('IP del cliente')}}: {{ ipAddress }}</small>
                <v-spacer></v-spacer>
                <v-btn
                    color="error"
                    :href="`/admin/print-order/${order}`"
                    target="_blank"
                ><v-icon left>mdi-file-pdf-box</v-icon> {{$t('Imprimir')}}</v-btn>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12" sm="6" md="4">
                        <div class="text-h6">{{$t('Forma de entrega')}}</div>
                        <div>
                            <v-radio-group
                                v-model="deliveryMethod"
                                row
                                disabled
                            >
                                <v-radio
                                    :label="$t('Delivery')"
                                    value="delivery"
                                ></v-radio>
                                <v-radio
                                    :label="$t('Recojo')"
                                    value="i_pick_up"
                                ></v-radio>
                                <v-radio
                                    :label="$t('Pedido para la mesa')"
                                    value="order_table"
                                ></v-radio>
                            </v-radio-group>
                        </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                        <div class="text-h6">{{$t('Recibir la orden')}}</div>
                        <div>
                            <v-radio-group
                                v-model="receiveOrder"
                                row
                                disabled
                            >
                                <v-radio
                                    :label="$t('Ahora mismo')"
                                    value="right_now"
                                ></v-radio>
                                <v-radio
                                    :label="$t('Programar entrega')"
                                    value="schedule_delivery"
                                ></v-radio>
                            </v-radio-group>
                            <v-row v-if="receiveOrder == 'schedule_delivery'">
                                <v-col cols="12">
                                    <v-text-field
                                        v-model="orderDay"
                                        :label="$t('Día')"
                                        prepend-icon="mdi-calendar"
                                        outlined
                                        dense
                                        hide-details
                                        disabled
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        v-model="orderTime"
                                        :label="$t('Hora')"
                                        prepend-icon="mdi-clock-time-four-outline"
                                        outlined
                                        dense
                                        hide-details
                                        disabled
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" v-if="deliveryMethod=='delivery'">
                        <div class="text-h6">{{$t('Dirección de entrega')}}</div>
                        <div>
                            <a :href="`https://www.google.com/maps/place/${lat},${lng}`" target="_blank">{{$t('Ver mapa')}}</a>
                            <br>
                            {{ deliveryAddress }}
                            <br>
                            {{ addressClarification }}
                        </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" v-if="deliveryMethod=='i_pick_up'">
                        <div class="text-h6">{{$t('Dirección de recojo')}}</div>
                        <div v-if="addressOfPickUp.includes('http')">
                            <a :href="addressOfPickUp" target="_blank">{{ addressOfPickUp }}</a>
                        </div>
                        <div v-else>
                            {{ addressOfPickUp }}
                        </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                        <div class="text-h6">{{$t('Datos cliente')}}</div>
                        <div>
                            {{ fullName }}
                            <br>
                            <a :href="`https://api.whatsapp.com/send?phone=${phonecode}${phoneNumber}`" target="_blank">
                                {{ phoneNumber }}
                            </a>
                        </div>
                        <div class="text-h6 mt-3" v-if="businessName">{{$t('Datos facturación')}}</div>
                        <div v-if="businessName">
                            <strong>{{$t('Razón social')}}:</strong> {{ businessName }}
                            <br>
                            <strong>{{$t('NIT/CI')}}:</strong> {{ document }}
                        </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                        <div class="text-h6">{{$t('Método de pago')}}</div>
                        <div>
                            <v-radio-group
                                v-model="paymentMethod"
                                row
                                disabled
                            >
                                <v-radio
                                    :label="$t('Pago Contraentrega')"
                                    value="cash_payment"
                                ></v-radio>
                                <v-radio
                                    :label="$t('Pago Qr/Transferencia Bancaria')"
                                    value="bank_payment"
                                ></v-radio>
                                <v-radio
                                    :label="$t('Pago tarjeta de débito/crédito')"
                                    value="card_payment"
                                ></v-radio>
                                <v-radio
                                    :label="$t('Pago por PagomóvilBDV')"
                                    value="bank_ven"
                                ></v-radio>
                            </v-radio-group>
                            <!-- <div v-if="paymentMethod=='bank_payment'">
                                <strong>Comprobante de pago</strong>
                                <v-img
                                    :src="previewCode"
                                    :lazy-src="previewCode"
                                ></v-img>
                            </div> -->
                        </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                        <div class="text-h6">{{$t('Estado')}}</div>
                        <div>
                            <v-select
                                :items="itemsStates"
                                :label="$t('Estado')"
                                outlined
                                dense
                                v-model="state"
                            ></v-select>
                            <div class="text-right">
                                <v-btn
                                    color="primary"
                                    small
                                    @click="updateState"
                                    :loading="loading"
                                >{{$t('Actualizar estado')}}</v-btn>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

        <v-card>
            <v-card-title>
                {{$t('Artículos')}}
            </v-card-title>
            <v-card-text>
                <v-simple-table>
                    <template v-slot:default>
                    <thead>
                        <tr>
                            <th class="text-left grey--text text--lighten-1">
                                {{$t('Producto')}}
                            </th>
                            <th class="text-left grey--text text--lighten-1">
                                {{$t('Precio')}}
                            </th>
                            <th class="text-left grey--text text--lighten-1">
                                {{$t('Cantidad')}}
                            </th>
                            <th class="text-left grey--text text--lighten-1">
                                {{$t('Total')}}
                            </th>
                            <th class="text-right grey--text text--lighten-1">
                                {{$t('Acciones')}}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, i) in cart" :key="i">
                            <td class="text-left">{{ item.name }}</td>
                            <td class="text-left">{{ money }} {{ item.price }}</td>
                            <td class="text-left">x{{ item.pivot.quantity }}</td>
                            <td class="text-left">{{ money }} {{ (+item.price) * (+item.pivot.quantity) }}</td>
                            <!-- <td class="text-left">{{ (+item.pivot.price)*(+item.pivot.quantity) }} {{ money }}</td> -->
                            <td class="text-right">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            v-bind="attrs"
                                            v-on="on"
                                            icon
                                            @click="openDetails(item, i)"
                                        >
                                            <v-icon color="grey">
                                                mdi-eye
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>{{$t('Ver')}}</span>
                                </v-tooltip>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colspan="3">
                                <strong class="text-h6">{{$t('Subtotal')}} {{ money }}</strong>
                            </td>
                            <td>
                                <strong class="text-h6">{{ money }} {{ subtotalFirst }}</strong>
                            </td>
                            <td></td>
                        </tr>
                        <tr>
                            <td colspan="3">
                                <strong class="text-h6">{{$t('Costo de envío')}}</strong>
                            </td>
                            <td>
                                <strong class="text-h6">{{ money }} {{ (total - subtotal - valCoupon) > 0 ? (total - subtotal - valCoupon) : (-1 * (total - subtotal - valCoupon)) }}</strong>
                            </td>
                            <td></td>
                        </tr>
                        <tr>
                            <td colspan="3">
                                <strong class="text-h6">Comer en local</strong>
                            </td>
                            <td>
                                <strong class="text-h6">{{ money }} {{ eatLocal }}</strong>
                            </td>
                            <td></td>
                        </tr>
                        <tr>
                            <td colspan="3">
                                <strong class="text-h6">Descuento</strong>
                            </td>
                            <td>
                                <strong class="text-h6">{{ money }} {{ valCoupon }}</strong>
                            </td>
                            <td></td>
                        </tr>
                        <tr v-if="deliveryMethod=='i_pick_up' && pickupDiscount>0">
                            <td colspan="3">
                                <strong class="text-h6">Descuento por recojo</strong>
                            </td>
                            <td>
                                <strong class="text-h6">{{ money }} {{ pickupDiscount }}</strong>
                            </td>
                            <td></td>
                        </tr>
                        <tr>
                            <td colspan="3">
                                <strong class="text-h5">Total {{ money }}</strong>
                            </td>
                            <td>
                                <strong class="text-h5">{{ money }} {{ ((total-valCoupon-pickupDiscount)>0)? ( (total-valCoupon-pickupDiscount) ) :0 }}</strong>
                            </td>
                            <td></td>
                        </tr>
                    </tfoot>
                    </template>
                </v-simple-table>
            </v-card-text>
        </v-card>

        <!-- dialog -->
        <v-dialog
            v-model="dialogProd"
            width="500"
            scrollable
            :fullscreen="$vuetify.breakpoint.smAndDown"
            transition="dialog-bottom-transition"
        >
            <v-skeleton-loader
                v-if="loadProd"
                class="white"
                type="card-avatar, article, actions"
            ></v-skeleton-loader>
            <v-card
                v-else
                class="mx-auto"
            >
                <v-fab-transition>
                    <v-btn
                        absolute
                        right
                        fab
                        small
                        style="top: 10px;"
                        @click="dialogProd=!dialogProd, loadProd=!loadProd"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-fab-transition>
                <v-img
                    class="align-end"
                    :aspect-ratio="16/9"
                    :gradient="`to bottom, #00000000, #00000096`"
                    :src="bannerProd"
                    v-if="bannerProd != 'none'"
                >
                    <v-card-title class="white--text">
                        {{ nameProd }}
                    </v-card-title>
                </v-img>
                <v-card-title v-else>
                    {{ nameProd }}
                </v-card-title>

                <v-card-text class="py-5 px-0">
                    <div class="px-5 mb-5" v-if="descriptionProd!='null'" v-html="descriptionProd"></div>

                    <template v-for="(row, j) in optionsProd">
                        <v-card-title :key="j" class="py-3 blue-grey lighten-4">
                            {{ row.title }}
                        </v-card-title>
                        <!-- multiple -->
                        <v-list :key="j+10" v-if="row.type == 'multiple'">
                            <!-- select quantity -->
                            <template dense>
                                <v-list-item v-for="(opt) in row.values" :key="opt.name">
                                    <v-list-item-content>
                                        <v-list-item-title>{{ opt.name }}</v-list-item-title>
                                        <v-list-item-subtitle v-if="(+opt.price)>0">{{ money }} (+{{ opt.price }})</v-list-item-subtitle>
                                    </v-list-item-content>

                                    <div class="d-flex align-center mr-3" v-if="row.ifQuantity">
                                        <v-sheet
                                            height="28"
                                            width="60"
                                            class="sheet-cant"
                                        >
                                            {{ opt.quantity }}
                                        </v-sheet>
                                    </div>

                                    <span :id="`${opt.name.replace(' ', '-')}_${opt.price}`" :data-details="`${opt.name}:${opt.price}:${opt.quantity}`"></span>

                                    <v-list-item-action>
                                        <v-checkbox
                                            v-model="row.tmpVal"
                                            :value="`${opt.name.replace(' ', '-')}_${opt.price}`"
                                            color="primary"
                                            disabled
                                        ></v-checkbox>
                                    </v-list-item-action>
                                </v-list-item>
                            </template>
                        </v-list>
                        <!-- multiple end -->
                        <!-- only -->
                        <v-list :key="j+20" v-if="row.type == 'only'">
                            <v-list-item-group
                                v-model="row.tmpValOnly"
                                active-class=""
                            >
                                <v-list-item v-for="(opt) in row.values" :key="opt.name" :value="opt.name+':'+opt.price" disabled>
                                    <template v-slot:default="{ active }">
                                        <v-list-item-content>
                                            <v-list-item-title>{{ opt.name }}</v-list-item-title>
                                            <v-list-item-subtitle v-if="(+opt.price)>0">{{ money }} (+{{ opt.price }})</v-list-item-subtitle>
                                        </v-list-item-content>

                                        <v-list-item-action>
                                            <v-icon color="grey" v-if="active">
                                                mdi-circle-slice-8
                                            </v-icon>
                                            <v-icon v-else>
                                                mdi-checkbox-blank-circle-outline
                                            </v-icon>
                                        </v-list-item-action>
                                    </template>
                                </v-list-item>
                            </v-list-item-group>
                        </v-list>
                        <!-- only end -->
                    </template>

                    <v-divider></v-divider>

                    <div class="px-5 pt-5" v-if="dataExtra!=''">
                        <strong>Dato extra</strong> <br>
                        {{ dataExtra }}
                    </div>

                </v-card-text>

                <v-card-actions>
                    <v-row no-gutters>
                        <v-col cols="6">
                            <small>Cantidad</small>
                            <div class="text-h5">x{{ quantity }}</div>
                        </v-col>
                        <!-- <v-col cols="6">
                            <small>Total a pagar</small>
                            <div class="text-h5">{{ quantity*price }} {{ money }}</div>
                        </v-col> -->
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- end dialog -->

        <!-- overlay -->
        <v-overlay :value="overlay" opacity=".9" z-index="10">
            <v-progress-circular
                indeterminate
                size="64"
                color="primary"
            ></v-progress-circular>
        </v-overlay>
        <!-- end overlay -->

    </v-container>
</template>
<script>
export default {
    data() {
        return {
            overlay: false,
            loading: false,
            breadcrumbs: [
                {
                    text: 'Pedidos',
                    disabled: false,
                    href: '/admin/orders',
                },
                {
                    text: 'Pedido',
                    disabled: true,
                    href: '',
                }
            ],
            // data
            numberOrder: null,
            deliveryMethod: 'delivery',
            receiveOrder: 'right_now',
            orderDay: null,
            orderTime: null,
            deliveryAddress: '',
            addressClarification: '',
            listAddressOfPickUp: [],
            addressOfPickUp: '',
            fullName: '',
            phoneNumber: '',
            phonecode: '',
            enablePaymentMethod: false,
            codePaymentMethod: '',
            paymentMethod: 'cash_payment',
            previewCode: '',
            proofPayment: null,
            remarkOrder: false,
            commentOrder: '',
            itemsStates: ['Pendiente', 'Completado', 'Reembolsado', 'Fallido'],
            state: '',
            date: null,
            ipAddress: '',
            businessName: '',
            document: '',
            // map
            showMap: false,
            address: '',
            lat: null,
            lng: null,
            // cart
            cart: {},
            total: 0,
            subtotal: 0,
            subtotalFirst: 0,
            // open product
            loadProd: true,
            dialogProd: false,
            bannerProd: '',
            nameProd: '',
            descriptionProd: '',
            optionsProd: [],
            quantity: 1,
            price: null,
            dataExtra: '',
            respMultiple: [],
            respMultipleVal: 0,
            respOnly: '',
            respOnlyVal: 0,
            nameCoupon: '',
            valCoupon: 0,
            eatLocal: 0,
            pickupDiscount: 0
        }
    },
    props: ['order', 'money'],
    watch: {
        dialogProd(e) {
            if (!e) {
                this.respMultiple = []
                this.respMultipleVal = 0

                this.respOnly = ''
                this.respOnlyVal = 0

                this.dataExtra = ''

                this.optionsProd = []
            }
        }
    },
    mounted() {
        this.getSingleProduct()
    },
    methods: {
        /**
         * Single product
         */
        async getSingleProduct () {
            this.overlay = true
            await axios.post(`/admin/single-order/${this.order}`, {})
            .then(response => {
                // console.log(response)
                this.numberOrder = response?.data?.number
                const d = new Date(response?.data?.created_at)
                this.date = d.getDate() +'-'+ (d.getMonth()+1) +'-'+ d.getFullYear() +'  '+ d.getHours()+':'+d.getMinutes()

                //
                this.deliveryMethod = response?.data?.delivery_method??''
                this.receiveOrder = response?.data?.receive_order??''
                this.orderDay = response?.data?.order_day??''
                this.orderTime = response?.data?.order_time??''

                // recojo
                this.addressOfPickUp = response?.data?.address_of_pickUp??''

                // direccion de delivery
                this.lat = +response?.data?.lat_map
                this.lng = +response?.data?.lng_map
                this.deliveryAddress = response?.data?.delivery_address
                this.addressClarification = response?.data?.address_clarification

                // datos cliente
                this.fullName = response?.data?.full_name
                this.phoneNumber = response?.data?.phone_number
                this.phonecode = response?.data?.code.replace('+', '')

                // metodo de pago
                this.paymentMethod = response?.data?.payment_method
                this.previewCode = response?.data?.proof_payment

                // estado
                this.state = response?.data?.state
                this.ipAddress = response?.data?.ip_address

                // cart
                this.subtotal = 0
                this.subtotalFirst = 0
                this.cart = response?.data?.products
                this.cart.forEach(element => {
                    // console.log(element);
                    const comple = JSON.parse(element.pivot.complements)
                    element.multi = comple.multi
                    element.only = comple.only

                    this.subtotal += (element.pivot.price)
                    this.subtotalFirst += (element.price * element.pivot.quantity)
                });
                this.total = response?.data?.total

                this.nameCoupon = response?.data?.coupon
                this.valCoupon = response?.data?.discount

                // invoice
                this.businessName = response?.data?.business_name
                this.document = response?.data?.document

                // eat local
                this.eatLocal = (response?.data?.eat_local)?response?.data?.eat_local:0

                // descuento por recojo
                this.pickupDiscount = (response?.data?.pickup_discount)?response?.data?.pickup_discount:0

                this.overlay = false
            })
            .catch(error => {
                // console.log(error)
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
                this.overlay = false
            })
        },

        /**
         * update state
         */
        async updateState() {
            this.loading = true
            await axios.post(`/admin/up-order/${this.order}`, {state: this.state})
            .then((response) => {
                // console.log(response);
                if (response.data === 'ok') {
                    this.$notify.success('Estado actualizado con éxito.')
                }
                this.loading = false
            })
            .catch((error) => {
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
                this.loading = false
            });

            if(this.state != 'Completado') { return; }

            try {
                this.loading = true;
                let {data} = await axios.post(`/admin/update-erp`, { order_id: this.order });
                if(data.success) {
                    this.$notify.success('Sistema de Gestión actualizado con éxito.')
                } else {
                    this.$alert(data.message);
                }
            } catch (error) {} finally { this.loading = false;  }
        },

        // open details
        async openDetails(prod, index) {
            this.tmpIndex = index
            this.loadProd = true
            this.dialogProd = true
            // console.log(prod);
            await axios.get(`/show-product/${prod.id}`)
            .then((response) => {
                // console.log(response);
                this.optionsProd = []
                this.respMultipleVal = 0

                this.respOnlyVal = 0

                this.prodId = response.data.id
                const tmpBanner = response.data.banner.split('/');
                this.bannerProd = (tmpBanner.slice(-1)[0]!='img-default.png') ? response.data.banner : 'none'
                this.galleryProd = response.data.gallery
                this.nameProd = response.data.name
                this.descriptionProd = response.data.description
                if (response.data.complements.length > 0) {
                    response.data.complements.forEach(element => {
                        var tmpValues = JSON.parse(element.values)
                        var tmpValues2 = []
                        var tmpValues3 = []
                        var tmp2Val = []
                        var tmp2ValOnly = undefined
                        if (element.type == 'multiple') {
                            if (tmpValues.length > 0) {
                                tmpValues.forEach(el => {
                                    // let txtVal = el.name+':'+el.price
                                    let txtVal = el.name.replace(' ', '-')+'_'+el.price
                                    // console.log(prod);
                                    if (prod.multi.length>0) {
                                        prod.multi.forEach(multi => {
                                            // console.log(multi);
                                            const selectedVal = multi.split(':')
                                            const selectId = selectedVal[0].replace(' ', '-')+'_'+selectedVal[1]
                                            if (selectId == txtVal) {
                                                this.respMultipleVal += (+el.price)*(+selectedVal[2])
                                                tmp2Val.push(txtVal)
                                            }
                                            tmpValues2[el.name.replace(' ', '-')+'_'+el.price] = 1
                                            tmpValues2[selectedVal[0].replace(' ', '-')+'_'+selectedVal[1]] = +selectedVal[2]
                                            // tmpValues2.push({name:selectedVal[0], price:+selectedVal[1], quantity: +selectedVal[2]})
                                        });
                                    } else {
                                        tmpValues2[el.name.replace(' ', '-')+'_'+el.price] = 1
                                    }
                                });
                            }

                            tmpValues.forEach(val => {
                                for (const key in tmpValues2) {
                                    if (key == val.name.replace(' ', '-')+'_'+val.price) {
                                        tmpValues3.push({name:val.name, price:val.price, quantity:tmpValues2[key]})
                                    }
                                }
                            });
                        }
                        if (element.type == 'only') {
                            if (tmpValues.length > 0) {
                                tmpValues.forEach(el => {
                                    // let txtVal = el.name+':'+el.price
                                    let txtVal = el.name+':'+el.price
                                    // console.log(prod);
                                    if (prod.only.length>0) {
                                        prod.only.forEach(only => {
                                            // console.log(only);
                                            const selectedVal = only.split(':')
                                            // const selectId = selectedVal[0].replace(' ', '-')+'_'+selectedVal[1]
                                            if (only == txtVal) {
                                                this.respOnlyVal += (+selectedVal[1])
                                                tmp2ValOnly = txtVal
                                            }
                                        });
                                    } else {
                                        // tmpValues2[el.name.replace(' ', '-')+'_'+el.price] = 1
                                    }
                                });

                            }
                            tmpValues3 = tmpValues
                            // console.log(tmpValues);
                            tmpValues.forEach(val => {
                                tmpValues3.quantity = 1
                            });
                        }
                        this.optionsProd.push({
                            title: element.title,
                            type: element.type,
                            values: tmpValues3,
                            select: element.select,
                            tmpVal: tmp2Val,
                            tmpValOnly: tmp2ValOnly,
                            ifQuantity: element.quantity,
                            quantity: 1,
                            isRequired: (element.required)?true:false
                        })
                        if (element.required) {
                            this.showRequired = true
                        }
                    });
                }
                this.price = (response.data.special_price) ? response.data.special_price : response.data.price

                // default data
                this.dataExtra = prod.extra
                this.quantity = prod.pivot.quantity
                this.respMultiple = prod.multi
                this.respOnly = prod.only

                setTimeout(() => {
                    this.loadProd = false
                }, 500);
            })
            .catch((error) => {
                console.log(error);
            })
        },
    },
}
</script>
